<template>
  <div>
    <div class="jumbotron">
      <div class="mask tra"></div>
      <b-row class="pt-5 text-left text-white" style="margin: auto;">
        <b-col cols="4" md="2" class="text-right">
          <b-img src="/iconss/traduttori.png" class="rounded-pill bg-white text-center p-2"></b-img>
        </b-col>
        <b-col cols="4">
          <h1>Traduttori</h1>
        </b-col>
      </b-row>
    </div>

    <b-row class="m-2 mx-auto rounded" style="max-width: 1460px">
      <b-col md="6" class="text-left mb-3">
        <h3>Scheda traduttore</h3>
      </b-col>
      <b-col md="6" class="text-right mb-3">
        <b-button pill size="sm" variant="primary" to="/translators" class="m-2" v-if="userType == 'organization'">
          <b-icon-arrow-left></b-icon-arrow-left> Torna alla lista</b-button
        >
      </b-col>
      <b-col md="12" class="text-left bg-light" id="wrapper">
        <b-row>
          <b-col md="12" class="text-right p-3">
            <b-button
              pill
              type="submit"
              size="sm"
              variant="outline-info"
              v-on:click="edit()"
              v-if="isAuthorized('self, admin')"
              >Modifica il tuo profilo</b-button
            >
          </b-col>
          <b-col md="2">
            <img
              v-if="user.foto != null && user.foto != ''"
              :src="`${apiPath}/${user.foto}`"
              v-bind="mainProps"
              class="rounded-circle"
            />
            <img v-else src="/img/default.png" v-bind="mainProps" class="rounded-circle" />
          </b-col>
          <b-col md="10">
            <strong
              ><h4 style="font-weight: bold">{{ user.first_name }}  {{ user.last_name }}</h4></strong
            >
            <h6>
              Lingua madre:
              <b>{{ madre.description }}</b>
            </h6>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <!--b-col md="2" class="text-left float-left d-block">
            <h6 style="font-weight: bold">Lingua Madre</h6>
            <div class="float-left d-block bg-white rounded-pill border py-2 px-3 m-1">
              <span class="pr-2" v-for="l in user.mother_languages" :key="l.id">
                <span class="flag">{{ l.flag }}</span>
                {{ l.description }}
              </span>
            </div>
          </b-col-->
          <b-col md="5" class="text-left float-left d-block">
            <h6 style="font-weight: bold">Traduco dalle seguenti lingue (lingue sorgenti)</h6>
            <div class="d-flex bg-white rounded-pill border p-2 m-1" style="max-width: fit-content">
              <span class="pl-2" v-for="l in user.src_languages" :key="l.id">
                <!--span class="flag">{{ l.flag }}</span-->
                {{ l }}
              </span>
            </div>
          </b-col>
          <b-col md="5" class="text-left float-left d-block">
            <h6 style="font-weight: bold">Traduco verso le seguenti lingue (lingue destinazione)</h6>
            <div class="d-flex bg-white rounded-pill border p-2 m-1" style="max-width: fit-content">
              <span class="pl-2" v-for="l in user.dest_languages" :key="l.id">
                <!--span class="flag">{{ l.flag }}</span-->
                {{ l }}
              </span>
            </div>
          </b-col>
          <b-col md="12" class="my-3" v-if="user.expertise !== null && user.expertise !== 'null'">
            <h6>
              <b>{{ user.expertise }}</b>
            </h6>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" class="bg-light">
        <hr class="btn-outline-info" />
        <b-row>
          <!--CURRICULUM VITAE-->
          <b-col md="3" class="float-left d-block">
            <small>CURRICULUM VITAE</small>
          </b-col>
          <b-col md="3" class="float-left d-block">
            <a :href="`${apiPath}/${user.cv}`" target="_blank">
              <b-button pill :disabled="disabledCV" variant="outline-info" size="sm" class="mx-3">
                VISUALIZZA CV
              </b-button>
            </a>
            <small v-show="disabledCV">CV non disponibile</small>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" class="bg-light">
        <b-row>
          <b-col md="12" align="center" justify="center" v-if="user.youtube != null">
            <hr class="btn-outline-info" />

            <!-- <youtube :video-id="videoId"></youtube> -->
            <video-embed css="embed-responsive-16by9" :src="user.youtube"></video-embed>
            
          </b-col>

        </b-row>
          <hr class="btn-outline-info" />
          <b-col cols="3"><h4 style="padding-right: 50px; margin-top: 50px;" v-if="user.userType == 'organization'"><b>Contattami</b></h4></b-col>
        <b-row>

          <!--FORM-->
          <b-form @submit="onSubmit" style="width: 100%;" v-if="userType == 'organization'">
            <b-row>
            <b-col md="10" style="">
              <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="4"
                label-cols-lg="3"
                label="La tua e-mail"
                label-for="input-horizontal"
              >
                <b-form-input
                  id="input-mail"
                  v-model="form.from"
                  type="email"
                  required
                  placeholder="Testo"
                  name="email"
                  style="width: 40%"
                  class="rounded-pill"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="4"
                label-cols-lg="3"
                label="Oggetto"
                label-for="input-horizontal"
              >
                <b-form-input
                  id="input-2"
                  v-model="form.oggetto"
                  required
                  placeholder="Testo"
                  name="email"
                  class="rounded-pill"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="4"
                label-cols-lg="3"
                label="Messaggio"
                label-for="input-horizontal"
              >
                <b-form-textarea
                  id="input-3"
                  v-model="form.testo"
                  required
                  placeholder="Testo"
                  size="lg"
                  name="email"
                  class="rounded"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            </b-row>
            <b-row>
            <b-col md="12" class="text-right mb-3">
              <!-- <b-button pill size="sm" variant="info">INVIA</b-button> -->
              <b-button type="submit" variant="info">INVIA</b-button>
            </b-col>
            </b-row>
          </b-form>

        </b-row>
        
      </b-col>
    </b-row>
  </div>
</template>

<script>
import util from "@/mixing/util";
import UserService from "@/services/user.service";
import { getIdFromURL } from "vue-youtube-embed";

export default {
  mixins: [util],
  data() {
    return {
      form: {
          from: '',
          to: '',
          oggetto: '',
          testo: '',
        },
      user_id: this.$route.params.user_id,
      user: {
        mother: ["it"],
      },
      myStyle: {
        backgroundColor: "#16a085",
      },
      mainProps: {
        blank: true,
        blankColor: "#777",
        width: 125,
        height: 125,
        class: "m1",
      },
      userType: '',
      apiPath: process.env.VUE_APP_ROOT,
    };
  },
  mounted() {
    UserService.getUser(this.$route.params.user_id).then((response) => {
      this.user = response.data;
      this.form.to = response.data.email;
    });
    this.userType = JSON.parse(localStorage.user).userType;
  },
  methods: {
    onSubmit(event) {
        event.preventDefault()
        UserService.contattami(this.form).then((response)=> {
          let title;
          let variant;
          let message;
          if(response.status == 200){
            title='Email inviata';
            variant='success';
            message=this.user.first_name+' '+this.user.last_name+' ha ricevuto la tua email e ti risponderà il prima possibile.';
            console.log(this.user);
          }

          this.$bvToast.toast(message?message:'Non è stato possibile inviare l\'email', {
                title: title?title:'Errore',
                autoHideDelay: 2000,
                solid: true,
                variant:variant?variant:'danger',
                appendToast: false
            });

          this.form={
            from: '',
            oggetto: '',
            testo: ''
          };


        });
      },
    edit: function () {
      this.$router.push(`/translators/edit/${this.user_id}`);
    },
    getLangsType(type) {
      if (this.user.languages == undefined) {
        return 0;
      }
      return this.user.languages.filter((val) => {
        if (val._joinData == undefined) {
          return false;
        }
        return val._joinData.type == type;
      });
    },
    isAuthorized(roles) {
      let rolesArray = roles.split(",").map(function (item) {
        return item.trim();
      });
      const user = JSON.parse(localStorage.getItem("user"));

      if (rolesArray.includes("self")) {
        if (this.user_id == user.id) {
          return true;
        }
      }

      if (rolesArray.includes("admin")) {
        if (user.role == "admin") {
          return true;
        }
      }
    },
  },
  computed: {
    videoId: function () {
      return getIdFromURL(this.user.youtube);
    },
    madre: function () {
      let x = this.getLangsType("M");
      if (x[0] === undefined) {
        return { id: "xx", description: "sconosciuta" };
      }
      return x[0];
    },
    disabledCV() {
      if (this.user.cv) return false;
      else return true;
    },
  },
};
</script>

<style scoped></style>
